import getLang from 'I18n/utils/getLang';
import { useAppContextQuery } from './useAppContextQuery';
export function usePersonalizationQuery(args) {
  var _args$options$variabl, _args$options;
  return useAppContextQuery({
    app: args.app,
    public: args.public,
    options: Object.assign({}, args.options, {
      variables: Object.assign({}, (_args$options$variabl = (_args$options = args.options) === null || _args$options === void 0 ? void 0 : _args$options.variables) !== null && _args$options$variabl !== void 0 ? _args$options$variabl : {}, {
        language: getLang()
      })
    })
  });
}